const YandexMap = () => (
    <div style={{ position: 'relative', overflow: 'hidden', width: '100%', height: '400px' }}>
      <iframe 
        src="https://yandex.ru/map-widget/v1/?ll=43.065716%2C55.961888&mode=poi&poi%5Bpoint%5D=43.065880%2C55.962631&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D17016649025&z=17"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        title="Школа №6 на карте"
      ></iframe>
    </div>
  );

  export default YandexMap